import styles from './MaterialPreview.module.scss';
import SelectedContent from '@src/components/program-details/selected-content/SelectedContent';
import { useCourseContent } from '../../../hooks/useCourseContent';
import { Events, useAnalytics, useUser } from '@src/hooks';

type Props = {
  onClose: () => void;
  needPrint?: boolean;
};

function MaterialPreview(props: Props) {
  const {
    onClose, needPrint
  } = props;
  const { trackEvent } = useAnalytics();
  const [user] = useUser();

  const { content: selectedContent, program, currentUnit, lesson } = useCourseContent();

  trackEvent(Events.actions.lessonMaterials, {
    course_name: program?.name,
    unit_name: currentUnit?.name,
    lesson_name: lesson?.name,
    schoolId: user?.schools?.[0]?.id,
    schoolName: user?.schools?.[0]?.name,
    userId: user?.id,
    userName: `${user?.firstName} ${user?.lastName}`,
  });

  return (
    <div className={styles.container}>
      <div className={styles.page}>
        {selectedContent && <SelectedContent content={selectedContent} goBack={onClose} isMaterial={true} needPrint={needPrint}/>}
      </div>
    </div>
  );
}

export default MaterialPreview;
